// extracted by mini-css-extract-plugin
export default {"footerWrapper":"Footer_footerWrapper__+vpvQ","footerItems":"Footer_footerItems__izqP0"};